module.exports = __webpack_public_path__ + "media/images/lp_consultation/ic-arrow-down-13c964c3413e53af76abcb5efe7d1909.svg";